import { useStore } from "@/state/store";
import { useCallback } from "react";
import type { DialogState } from "@/state/store";

export function useAppDialog() {
  const storeOpenDialog = useStore((state) => state.openDialog);
  const storeCloseDialog = useStore((state) => state.closeDialog);

  // Wrap to handle potential undefined (shouldn't happen but defensive)
  const openDialog = useCallback(
    (dialog: DialogState) => {
      if (storeOpenDialog) {
        storeOpenDialog(dialog);
      } else {
        console.error("[useAppDialog] openDialog not available in store");
      }
    },
    [storeOpenDialog]
  );

  const closeDialog = useCallback(() => {
    if (storeCloseDialog) {
      storeCloseDialog();
    }
  }, [storeCloseDialog]);

  const alert = useCallback(
    (message: string, title?: string) => {
      openDialog({
        type: "alert",
        message,
        title,
      });
    },
    [openDialog]
  );

  const confirm = useCallback(
    (message: string, onConfirm: () => void, title?: string, onCancel?: () => void) => {
      openDialog({
        type: "confirm",
        message,
        title,
        onConfirm,
        onCancel,
      });
    },
    [openDialog]
  );

  return {
    openDialog,
    alert,
    confirm,
    close: closeDialog,
  };
}
